export const CLOSE = 'close'
export const LOGIN = 'login'
export const MAX_WIDTH = '564px'
export const CONTINUE = 'Continue'
